module.exports = __webpack_public_path__ + "static/img/cooperation_banner-1.5a086190.png";